import React from 'react'
import Layout from '../../layout'

function Home() {
  return (
    <>
        <Layout props='home'></Layout>
    </>
  )
}

export default Home